function formatDigit(data) {
  return `0000${data}`.slice(-2);
}

export default function (valor) {
  const date = new Date(`${valor} 00:00:01`);
  if (!isNaN(date.getTime())) {
    return `${formatDigit(date.getDate())}/${formatDigit(date.getMonth() + 1)}/${date.getFullYear()}`;
  }
  return valor;
}
